import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";

const ConfirmDialog = ({ open, title, message, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>{title || "Confirm"}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message || "Are you sure you want to proceed?"}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <MDButton onClick={onCancel} color="secondary" size="small">Cancel</MDButton>
      <MDButton onClick={onConfirm} color="error" size="small">Delete</MDButton>
    </DialogActions>
  </Dialog>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  title: "Confirm",
  message: "Are you sure you want to proceed?",
};

export default ConfirmDialog;
